// extracted by mini-css-extract-plugin
export default {"alert":"style_alert__NTdPk","btnContainer":"style_btnContainer__LoIdr","danger":"style_danger__rDrBk","success":"style_success__NVWCy","btn":"style_btn__EJHzI"};